export function isEan13Barcode(code: string): boolean {
  return /^\d{13}$/i.test(code);
}
